import React from "react";
import { graphql } from "gatsby";
import BrandsPage from "./brandsPage";

const Index = () => {
  return <BrandsPage />;
};

export default Index;

export const Head = () => <title>Tycoon - Brands</title>;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

